// src/pages/ConfirmPlanChange.jsx
import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../api";

export default function ConfirmPlanChange() {
  const [status, setStatus] = useState("working");
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || params.get("t"); // accept both
  const didCallRef = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus("err");
      return;
    }
    if (didCallRef.current) return;
    didCallRef.current = true;

    // Hit backend to confirm and apply the pending change (edit or delete)
    api
      .post("/confirm-plan-change", { token })
      .then((res) => {
        // stash response for the redirect effect
        window.__CONFIRM_RESP__ = res;
        setStatus("ok");
      })
      .catch((err) => {
        console.error("[confirm-plan-change] error", err);
        setStatus("err");
      });
  }, [token]);

  // On success, redirect the user back to /plans with a flag
  useEffect(() => {
    if (status !== "ok") return;

    const last = window.__CONFIRM_RESP__;
    const action =
      last?.data?.action ||
      (last?.data?.deleted ? "delete" : null); // use whatever your backend returns; fallback to generic

    if (action === "delete") {
      navigate("/plans?confirmed=delete", { replace: true });
    } else {
      // default covers edit/create
      navigate("/plans?confirmed=1", { replace: true });
    }
  }, [status, navigate]);

  return (
    <div style={{ maxWidth: 520, margin: "48px auto", padding: 16, textAlign: "center" }}>
      {status === "working" && (
        <>
          <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Confirming…</h2>
          <p>Please wait a moment.</p>
        </>
      )}

      {status === "ok" && (
        <>
          <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Confirmed</h2>
          <p>Redirecting you back to your Buy Plans…</p>
        </>
      )}

      {status === "err" && (
        <>
          <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Confirmation failed</h2>
          <p>The link may be expired or already used.</p>
          <button
            onClick={() => navigate("/plans?confirmError=1", { replace: true })}
            style={{ marginTop: 12, padding: "8px 14px", borderRadius: 8 }}
          >
            Return to Buy Plans
          </button>
        </>
      )}
    </div>
  );
}
